import React, { useEffect, useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap';
import { usePublicRoutes } from '../../Router/router.link';
import { all_routes } from '../../Router/all_routes';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import CashSessionModal from './CashSessionModal';
import useCashSession from './useCashSession';

// redux
import { setCurrent_location } from "../../core/redux/action";

// MUI
import Avatar from "@mui/material/Avatar";

// utils
import utils from "../../utils/utils";

const PosHeader = () => {
  const user_infos = useSelector((state) => state.rootReducer.user_infos);
  const user_location = useSelector((state) => state.rootReducer.user_location);
  const current_location = useSelector((state) => state.rootReducer.current_location);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const route = all_routes;
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { stringAvatar } = utils;
  const dispatch = useDispatch();
  const role = user_infos?.role;
  const { publicRoutes } = usePublicRoutes();
  const canOpenInvoices = publicRoutes.some(item => item.path === all_routes.invoice);
  const { cashSession, refreshCashSession } = useCashSession();

  // user location where general is false
  const locations = user_location.filter((location) => !location.general);

  useEffect(() => {
    const notInArray = !locations.some(item => item._id === current_location?._id);

    if (notInArray && locations?.length) {
      dispatch(setCurrent_location(locations[0]));
    }
  }, [current_location, locations, dispatch]);

  const redirectUser = useMemo(() => {
    switch (role) {
      case "su":
      case "admin":
        return all_routes.salesdashboard;
      case "compta":
      case "manager":
      case "salon_manager":
        return all_routes.invoice;
      case "logistic":
        return all_routes.managestock;
      case "rh":
        return all_routes.employeegrid;
      case "com":
        return all_routes.customers;
      default:
        return all_routes.profile;
    }
  }, [role]);

  useEffect(() => {
    refreshCashSession();
  }, [refreshCashSession]);

  const handleRole = (role) => {
    switch (role) {
      case "su":
        return "Super Admin";
      case "admin":
        return "Admin";
      case "salon_manager":
        return lang === "fr" ? "Caissière" : "Cashier";
      case "manager":
        return "Manager";
      case "logistic":
        return lang === "fr" ? "Logistique" : "Logistics";
      case "compta":
        return lang === "fr" ? "Comptable" : "Accountant";
      case "rh":
        return lang === "fr" ? "RH" : "HR";
      case "com":
        return lang === "fr" ? "Commercial" : "Sales";
      default:
        return lang === "fr" ? "Inconnu" : "Unknown";
    }
  }

  // Call this from a click handler (needs a user gesture for most browsers)
  function toggleFullscreen(elem) {
    var doc = document;
    elem = elem || doc.documentElement;

    var inIframe = (function () {
      try { return window.self !== window.top; } catch (_) { return true; }
    })();

    var isFull = doc.fullscreenElement || doc.webkitFullscreenElement ||
      doc.mozFullScreenElement || doc.msFullscreenElement;

    function request(el) {
      if (el.requestFullscreen) return el.requestFullscreen();
      if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
      if (el.mozRequestFullScreen) return el.mozRequestFullScreen();
      if (el.msRequestFullscreen) return el.msRequestFullscreen();
      return Promise.reject(new Error('Fullscreen API not available'));
    }

    function exit() {
      if (doc.exitFullscreen) return doc.exitFullscreen();
      if (doc.webkitExitFullscreen) return doc.webkitExitFullscreen();
      if (doc.mozCancelFullScreen) return doc.mozCancelFullScreen();
      if (doc.msExitFullscreen) return doc.msExitFullscreen();
      return Promise.reject(new Error('Exit Fullscreen API not available'));
    }

    if (!isFull) {
      var p = request(elem);
      if (inIframe) {
        // If the browser blocks child fullscreen, ask the parent to fullscreen the iframe.
        (p && typeof p.catch === 'function' ? p.catch.bind(p) : function (f) { f(); })(function () {
          window.parent.postMessage({ type: 'POS_TOGGLE_FULLSCREEN', action: 'enter' }, '*');
        });
      }
    } else {
      var q = exit();
      if (inIframe) {
        (q && typeof q.catch === 'function' ? q.catch.bind(q) : function (f) { f(); })(function () {
          window.parent.postMessage({ type: 'POS_TOGGLE_FULLSCREEN', action: 'exit' }, '*');
        });
      }
    }
  }

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);

  return <>
    <header className="ui-topbar ui-pos-topbar">
      <Link to={redirectUser} className="ui-pos-brand" aria-label={t('ui.backToManagement')}><img src="/assets/img/logo.png" alt="SpecificsPOS" /></Link>
      <Link to={redirectUser} className="ui-icon-button" aria-label={t('ui.backToManagement')} title={t('ui.backToManagement')}><i className="ti ti-arrow-left" aria-hidden="true" /></Link>
      <Dropdown className="ui-location-menu">
        <Dropdown.Toggle variant="light" className="ui-location-toggle" id="pos-location-menu"><span><small>{t('ui.workspace')}</small><strong>{current_location?.name || t('ui.chooseLocation')}</strong></span></Dropdown.Toggle>
        <Dropdown.Menu>{locations.map(item => <Dropdown.Item key={item._id} active={item._id === current_location?._id} onClick={() => dispatch(setCurrent_location(item))}>{item.name}</Dropdown.Item>)}</Dropdown.Menu>
      </Dropdown>
      <div className="ui-topbar-actions">
        {canOpenInvoices && <Link to={route.invoice} className="btn btn-outline-secondary ui-pos-invoices"><i className="ti ti-receipt" aria-hidden="true" />{t('invoices')}</Link>}
        {['su', 'admin', 'compta', 'manager', 'salon_manager', 'logistic', 'rh'].includes(role) && <button type="button" className="btn btn-outline-secondary ui-cash-session" onClick={() => setSessionModalOpen(true)}>
          <span className={`ui-session-dot ${cashSession?.session ? 'is-open' : ''}`} />{cashSession?.session ? t('cash closure') : t('cash opening')}
        </button>}
        <Dropdown><Dropdown.Toggle variant="light" className="ui-language-toggle" id="pos-language-menu" aria-label={t('ui.language')}>{lang.startsWith('fr') ? 'FR' : 'EN'}</Dropdown.Toggle>
          <Dropdown.Menu align="end"><Dropdown.Item active={lang.startsWith('fr')} onClick={() => i18n.changeLanguage('fr')}>Français</Dropdown.Item><Dropdown.Item active={lang.startsWith('en')} onClick={() => i18n.changeLanguage('en')}>English</Dropdown.Item></Dropdown.Menu>
        </Dropdown>
        <button type="button" className="ui-icon-button ui-fullscreen" aria-label={t('ui.fullscreen')} onClick={() => toggleFullscreen()}><i className={`ti ti-${isFullscreen ? 'minimize' : 'maximize'}`} aria-hidden="true" /></button>
        <Dropdown><Dropdown.Toggle variant="light" className="ui-profile-toggle" id="pos-account-menu" aria-label={t('myprofile')}><Avatar {...stringAvatar(user_infos?.name || '')} /></Dropdown.Toggle>
          <Dropdown.Menu align="end"><Dropdown.Header>{user_infos?.name}<br />{handleRole(role)}</Dropdown.Header><Dropdown.Item as={Link} to={route.profile}>{t('myprofile')}</Dropdown.Item><Dropdown.Divider /><Dropdown.Item as={Link} to={route.signin} onClick={() => sessionStorage.removeItem('token')}>{t('logout')}</Dropdown.Item></Dropdown.Menu>
        </Dropdown>
      </div>
    </header>
    <CashSessionModal open={sessionModalOpen} onClose={() => setSessionModalOpen(false)} />
  </>;
};
export default PosHeader;
